// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603251510/js/" + chunkId + "." + {"44":"276f3692","225":"118c0f47","481":"11e5d79b","486":"0e2ec6fd","770":"d168eded"}[chunkId] + ".0.4011356507782917.chunk.js";
};